const config = {
  updateTime: 1000 * 60 * 0.2,
  animateTime: 800,
  file: ['.jpg', '.png', '.gif', '.bmp', '.xlsx', '.rar', '.xls', '.xlsm', '.doc', '.docx', '.zip', '.pdf', '.pptx', '.vsdx', '.txt', '.jpeg'].join(',')
}

export default config
